export const km = {
  msg:
    {
      'username': 'ឈ្មោះអ្នកប្រើ',
      'password': 'ពាក្យសម្ងាត់',
      'login': 'Login',
      'username_not_found': 'សូមបញ្ចូលឈ្មោះអ្នកប្រើរបស់អ្នក។',
      'password_not_found': 'សូមបញ្ចូលពាក្យសម្ងាត់របស់អ្នក។',
      'error': 'ឈ្មោះអ្នកប្រើ ឬពាក្យសម្ងាត់ពុំត្រឹមត្រូវទេ។',
      'changeLanguage': '',
      'designation': 'Designation',
      'lang-en': 'English',
      'lang-ms': 'Bahasa Melayu',
      'submit_button_text': 'Submit',
      'enter': 'បញ្ចូល',
      'en': 'English',
      'ms': 'Bahasa Melayu',
      'zh': 'Chinese',
      'ta': 'Tamil',
      'km': 'Khmer',
      'th': 'Thai',
      'id': 'Bahasa Indonesia',
      'ar': 'Arabic',
      'blank_username_field': 'សូមបញ្ចូលឈ្មោះអ្នកប្រើរបស់អ្នក។',
      'blank_password_field': 'សូមបញ្ចូលពាក្យសម្ងាត់របស់អ្នក។',
      'invalid_credentials': 'ឈ្មោះអ្នកប្រើ ឬពាក្យសម្ងាត់ពុំត្រឹមត្រូវទេ។',
      'copyright': 'ដែលនាំមកជូនដោយ Global Psytech',

      'register_hyperlink_login_1': 'Sign up',
      'register_hyperlink_login_2': 'to create an account',
      'register_button': 'Register',

      'back_button': 'Cancel',
      'cancel_button': 'Cancel',
      'successfully_register': 'You have successfully registered. Please log in using your registered username and password.',
      'cloned_user': 'Your last GFI score is still valid. Hence, you do not need to retake the GFI assessment.'
    }
}
